import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from "@elastic/eui";
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Recording/Video/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmPerm';
import VideoTable from 'components/Web_User_Interface/1440p_Series/Recording/Video/VideoTable';
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "Aufgaben Menü // Video",
  "path": "/Web_User_Interface/1440p_Serie/Aufnahme_Aufgaben/Video/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Snapshots in einem einstellbaren Zeitintervall aufnehmen und in einer Drittanbieter-Software zusammenführen um ein TimeLapse Video zu erstellen. Sie können die Snapshots auch mit einem festen Dateinamen hochladen. Dies wird immer die letzte Datei überschreiben und erlaubt es Ihnen ein Live Bild Ihrer Kamera auf Ihrer Webseite anzuzeigen.",
  "image": "./WebUI_1440p_SearchThumb_Tasks_Video_Recording.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Tasks_Video_Recording.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title="Aufgaben Menü // Video" dateChanged="2021-12-12" author="Mike Polinowski" tag="INSTAR IP Camera" description="Snapshots in einem einstellbaren Zeitintervall aufnehmen und in einer Drittanbieter-Software zusammenführen um ein TimeLapse Video zu erstellen. Sie können die Snapshots auch mit einem festen Dateinamen hochladen. Dies wird immer die letzte Datei überschreiben und erlaubt es Ihnen ein Live Bild Ihrer Kamera auf Ihrer Webseite anzuzeigen." image="/images/Search/WebUI_1440p_SearchThumb_Tasks_Video_Recording.png" twitter="/images/Search/WebUI_1440p_SearchThumb_Tasks_Video_Recording.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Web_User_Interface/1440p_Series/Recording/Video/" locationFR="/fr/Web_User_Interface/1440p_Series/Features/Video/" crumbLabel="Video" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "aufgaben-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#aufgaben-men%C3%BC",
        "aria-label": "aufgaben menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Aufgaben Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "konfigurieren-einer-videoaufnahme-auf-sd-karte",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#konfigurieren-einer-videoaufnahme-auf-sd-karte",
        "aria-label": "konfigurieren einer videoaufnahme auf sd karte permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Konfigurieren einer Videoaufnahme auf SD-Karte`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/e2e58/1440p_Settings_Task_Video.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.60869565217391%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACo0lEQVQoz1WS204TURiFeQwST/XCtEO5MsGCEUqEdgY6nZnOTKfT4VBaWmDk2JMpBSyKpyCaeCN4o0A0Jp5NRKKJEQ9XXvkCPstn2oLGiy97//9OVlbW2i3t7e0IgoCYqTFQ3CE0+5C+6S0uTm/RM7VJ0D1karMxH9HrPkAu7RCfW+fUyWO0trbi8Xho8fv9CD4f6uQ1nNozEovbJJd3sZd3iS/uYFa2/1KfrepuA3tpl9ztt6i5GoLXhyDUjflpaWtrazrs72XU1nFMlYQuk9CjmIqELocxoiJaJMxgKIjU100o2EV/8DxqpJ9IOIymjiKGFQLnupoO66JhUcIwLVQt1kCLGSiqhqyoyNEokViCiGahqCqabjTfYzFMJUFyIIMsynR1BpqCXq8XRVEol8uUSiWKxQKlYp5iYYFCfp5SoX7Pc7lcZDwzhqZEMWIqqqYyZhps5JJkRgbo6T4U9Pl8yLKM67pMTkww6c5wKV/FzS/iLlS4VKg2mCkukZ5aID6Sw05NYgxlyaQc7q9lGR/poedC52Ep9QxFETuZRFMi6GPzJG58JH59H2ttD2vtw1/smx9xbn9ieP0z+sorqqs3+flum/khkUDg3D+HkiSRSo1iGRpWrszQxg+cO99w1r/g3PmKs37QPBu7A4Y3vqOvvmdpucbv/T225ibo6Dhbb7npMCRK6IlhIoqGmZ4nefUV9upLkrXn2KsvSNZeYK88xV5+QuLKM8xrrxms7LBSWeTXl30eV2fQ+o9K8QmNb7EypVPJajiWTkw3MIz/iaemMbMlhu00RVXDlRXy2QxvNu9xNa0TFwO0tPv9nPEK6FI3jwohHsxexFLChMISkiQ2oqhTzziSrjIwfRfHyHKru5e1PpFgoJPjJ05w2uPB4znNH34NyrZeEEupAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/e4706/1440p_Settings_Task_Video.avif 230w", "/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/d1af7/1440p_Settings_Task_Video.avif 460w", "/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/7f308/1440p_Settings_Task_Video.avif 920w", "/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/c986f/1440p_Settings_Task_Video.avif 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/a0b58/1440p_Settings_Task_Video.webp 230w", "/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/bc10c/1440p_Settings_Task_Video.webp 460w", "/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/966d8/1440p_Settings_Task_Video.webp 920w", "/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/b8544/1440p_Settings_Task_Video.webp 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/81c8e/1440p_Settings_Task_Video.png 230w", "/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/08a84/1440p_Settings_Task_Video.png 460w", "/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/c0255/1440p_Settings_Task_Video.png 920w", "/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/e2e58/1440p_Settings_Task_Video.png 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/7d8848d41c6cfdac4ad5e14f4a4730bf/c0255/1440p_Settings_Task_Video.png",
              "alt": "Web User Interface - 1440p Serie - Aufnahme Menu",
              "title": "Web User Interface - 1440p Serie - Aufnahme Menu",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <VideoTable mdxType="VideoTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      